// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://klsdmuldpwprmosyhxax.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtsc2RtdWxkcHdwcm1vc3loeGF4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMzNDE1MjcsImV4cCI6MjA1ODkxNzUyN30.XQEq1S7EgfQimpFQBwupSy0HkR4-EHVG1Ko_ZhUfDe4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);